import type React from "react";
import {useState} from "react";
import {TextField} from "@mui/material";

type ApproverNoteFieldProps = {
    /** The saved note */
    note: string;
    disabled: boolean;
    /** Called when the field loses focus with a different note */
    onSave: (note: string) => void;
};

/**
 * The approver's note on one category, in a table cell: saved when the field loses focus, like a draft
 * that is kept. The grid's own keys (space, arrows) are stopped so they type into the field.
 */
export const ApproverNoteField: React.FC<ApproverNoteFieldProps> = ({note, disabled, onSave}) => {
    const [value, setValue] = useState(note);
    // Follow a saved note that changed elsewhere (undo / redo), unless it is being edited.
    const [saved, setSaved] = useState(note);
    if (saved !== note) {
        setSaved(note);
        setValue(note);
    }

    return (
        <TextField
            value={value}
            onChange={e => setValue(e.target.value)}
            onBlur={() => {
                if (value.trim() !== note) onSave(value.trim());
            }}
            onKeyDown={e => e.stopPropagation()}
            placeholder="Add a note for the requester"
            disabled={disabled}
            multiline
            fullWidth
            size="small"
            variant="standard"
            sx={{py: 1}}
        />
    );
};
